"use client";

import { c as _c } from "react/compiler-runtime";
import { useTeamsControllerFindAll } from "@dc/gateway-jsonapi";
import { useRouter } from "next/navigation";
import { useCallback, useEffect, useState } from "react";
import { buildOrgTeamPath } from "@/lib/orgTeamPath";
export type OrganizationSwitchError = "no_accessible_teams";
export function useEmsEntitlementGate() {
  const $ = _c(21);
  const router = useRouter();
  const [pendingOrganizationId, setPendingOrganizationId] = useState(null);
  const [organizationSwitchError, setOrganizationSwitchError] = useState(null);
  let t0;
  if ($[0] !== pendingOrganizationId) {
    t0 = pendingOrganizationId ? {
      "scope.parent.organization.id": pendingOrganizationId
    } : undefined;
    $[0] = pendingOrganizationId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      size: 1
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = {
      filter: t0,
      sort: "name",
      page: t1
    };
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = !!pendingOrganizationId;
  let t4;
  if ($[5] !== t3) {
    t4 = {
      query: {
        enabled: t3
      }
    };
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data: pendingOrgTeams,
    isFetching: isPendingOrgTeamsLoading
  } = useTeamsControllerFindAll(t2, t4);
  let t5;
  if ($[7] !== isPendingOrgTeamsLoading || $[8] !== pendingOrgTeams?.data || $[9] !== pendingOrganizationId || $[10] !== router) {
    t5 = () => {
      if (!pendingOrganizationId || isPendingOrgTeamsLoading) {
        return;
      }
      const firstTeamId = pendingOrgTeams?.data[0]?.id;
      if (firstTeamId) {
        router.push(buildOrgTeamPath("/files", {
          orgId: pendingOrganizationId,
          teamId: firstTeamId
        }));
      } else {
        setOrganizationSwitchError("no_accessible_teams");
      }
      setPendingOrganizationId(null);
    };
    $[7] = isPendingOrgTeamsLoading;
    $[8] = pendingOrgTeams?.data;
    $[9] = pendingOrganizationId;
    $[10] = router;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isPendingOrgTeamsLoading || $[13] !== pendingOrgTeams || $[14] !== pendingOrganizationId || $[15] !== router) {
    t6 = [pendingOrganizationId, isPendingOrgTeamsLoading, pendingOrgTeams, router];
    $[12] = isPendingOrgTeamsLoading;
    $[13] = pendingOrgTeams;
    $[14] = pendingOrganizationId;
    $[15] = router;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  useEffect(t5, t6);
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = organizationId => {
      setOrganizationSwitchError(null);
      setPendingOrganizationId(organizationId);
    };
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const handleOrganizationSelected = t7;
  const t8 = !!pendingOrganizationId || !!organizationSwitchError;
  let t9;
  if ($[18] !== organizationSwitchError || $[19] !== t8) {
    t9 = {
      handleOrganizationSelected,
      organizationSwitchError,
      isSwitchingOrganization: t8
    };
    $[18] = organizationSwitchError;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}